module.exports = "\n<gt-image-list [imageList]=\"info.images\" [imageRatio]=\"AspectRatio.Rectangle\"></gt-image-list>\n<div class=\"content\">\n  <div class=\"view-title\">{{ info.leftContent.title }}</div>\n  <div class=\"section\" *ngIf=\"info.leftContent\" [innerHTML]=\"info.leftContent.html\"></div>\n  <div class=\"section\" *ngIf=\"info.rightContent\" [innerHTML]=\"info.rightContent.html\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/about.component.html
// module id = ./src/app/components/about.component.html
// module chunks = main